import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { ChannelReviewSearchParams } from '@tokeet-frontend/reviews'

@Component({
  selector: 'app-reviews-dialog',
  templateUrl: './reviews-dialog.component.html',
  styleUrls: ['./reviews-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class ReviewsDialogComponent implements OnInit {
  filters: ChannelReviewSearchParams
  constructor(private dialogRef: MatDialogRef<ReviewsDialogComponent>) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }
}
